<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {}
}
</script>

<style>
@import url('./css/font.css');
@import url('./css/color.css');
@import url('./css/base.css');
@font-face {
  font-family: CustomHelvetica;
  src: url("./assets/helveticaltstd-roman.otf");
}
#app{
  font-family:-apple-system, BlinkMacSystemFont, 'PingFang SC',
  'Helvetica Neue', STHeiti, 'Microsoft Yahei', Tahoma, Simsun, sans-serif;
}
.digitFont{
  font-family: CustomHelvetica;
}


.sep {
  height: 1px;
  background-color: #ebebeb;
}

.gone {
  display: none;
}
</style>
